import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../assets/styles/po_creation.scss';

export default function EditPurchaseOrder() {
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    poNumber: 'PO-2025-001234',
    poDate: '2025-11-07',
    expectedDeliveryDate: '2025-11-15',
    priorityLevel: 'Normal',
    paymentTerms: '',
    currency: '',
    freightTerms: '',
    deliveryTerms: '',
    tradeScenario: 'IN Intra-State (Same State in India)',
    tradeType: 'Intra-State Trade (CGST + SGST)',
    tradeLocation: 'Karnataka -> Karnataka',
    portOfLoading: '',
    portOfDischarge: '',
    customsBroker: '',
    hsCode: '',
    countryOfOrigin: '',
    incoterms: '',
    requiredDocuments: '',
    exportType: 'LUT (Letter of Undertaking) - 0% IGST',
    lutArn: '',
    buyerAddress: 'Plot 45, Industrial Area, Phase-2, Bangalore, Karnataka - 560058',
    buyerGstNumber: '29AABCT1332L1Z5',
    buyerState: 'Karnataka',
    buyerCountry: 'India',
    sellerAddress: '89, Electronic City, Bangalore, Karnataka - 560100',
    sellerGstNumber: '29BBCDE5678M1Z3',
    sellerState: 'Karnataka',
    sellerCountry: 'India'
  });

  const [lineItems, setLineItems] = useState([
    {
      id: 1,
      description: 'Industrial Grade Electrical Components',
      hsn: '8517',
      quantity: 100,
      uom: 'pcs',
      unitPrice: 1200,
      discount: 0,
      cgst: 9,
      sgst: 9,
      igst: 18,
      customsDuty: 10,
      cess: 0,
      tax: 0,
      total: 170600.11
    },
    {
      id: 2,
      description: 'Control Panel Assembly',
      hsn: '8537',
      quantity: 25,
      uom: 'units',
      unitPrice: 5000,
      discount: 0,
      cgst: 9,
      sgst: 9,
      igst: 18,
      customsDuty: 10,
      cess: 0,
      tax: 0,
      total: 177708.45
    }
  ]);

  const [deliverySchedules, setDeliverySchedules] = useState([
    {
      id: 1,
      item: '1',
      quantity: 50,
      deliveryDate: '2025-11-10',
      location: 'Warehouse A - Bangalore'
    },
    {
      id: 2,
      item: '1',
      quantity: 50,
      deliveryDate: '2025-11-15',
      location: 'Warehouse A - Bangalore'
    }
  ]);

  const [termsConditions, setTermsConditions] = useState([
    { id: 1, text: 'All items must be BIS certified and meet the specifications mentioned in the RFQ.' },
    { id: 2, text: 'Delivery to be completed as per the schedule mentioned. Late delivery penalties apply.' },
    { id: 3, text: 'Payment will be released within 30 days of delivery and invoice submission.' },
    { id: 4, text: 'Supplier must provide installation support and training if required.' },
    { id: 5, text: 'Quality inspection will be conducted upon delivery. Rejection criteria as per industry standards.' }
  ]);

  const [cifConfig, setCifConfig] = useState({
    freightPercent: 5,
    insurancePercent: 1.5,
    handlingFixed: 5000
  });

  const [internationalCharges, setInternationalCharges] = useState({
    shippingCharges: 12250,
    insuranceCharges: 3675,
    handlingCharges: 5000
  });

  const [specialInstructions, setSpecialInstructions] = useState('Please ensure all items are packed securely. Provide advance notice 48 hours before dispatch. Include packing list and test certificates with shipment.');

  const [attachments, setAttachments] = useState([
    { id: 1, name: 'RFQ-2025-567890.pdf' },
    { id: 2, name: 'Technical-Specs.pdf' }
  ]);

  const [showPreviewModal, setShowPreviewModal] = useState(false);

  const countryOptions = [
    'United States',
    'China',
    'Japan',
    'Germany',
    'United Kingdom',
    'France',
    'India',
    'South Korea',
    'Italy',
    'Canada',
    'Australia',
    'Brazil',
    'Mexico',
    'Spain',
    'Netherlands',
    'Russia',
    'Switzerland',
    'Belgium',
    'Sweden',
    'Poland',
    'Other'
  ];

  const stateOptions = [
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chhattisgarh',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal',
    'Other'
  ];

  const quotationData = {
    quotationId: 'QUO-2025-789012',
    linkedRFQ: 'RFQ-2025-567890',
    quoteDate: '2025-11-01',
    validUntil: '2025-11-30',
    sellerCompany: 'TechSupply Industries Pvt. Ltd.',
    contactPerson: 'Amit Sharma',
    contactEmail: 'amit@techsupply.com',
    contactPhone: '+91 98765 12345'
  };

  const buyerDetails = {
    companyName: 'ABC Manufacturing Ltd.',
    address: 'Plot 45, Industrial Area, Phase-2, Bangalore, Karnataka - 560058',
    gstNumber: '29AABCT1332L1Z5',
    state: 'Karnataka',
    country: 'India',
    contactPerson: 'Rajesh Kumar',
    email: 'rajesh@abcmfg.com',
    phone: '+91 98765 43210'
  };

  const sellerDetails = {
    companyName: 'Karnataka Electronics Pvt. Ltd.',
    address: '89, Electronic City, Bangalore, Karnataka - 560100',
    gstNumber: '29BBCDE5678M1Z3',
    state: 'Karnataka',
    country: 'India',
    contactPerson: 'Suresh Reddy',
    email: 'suresh@karnataka-elec.com',
    phone: '+91 98765 11111'
  };

  // Helper function to check if trade scenario is international
  const isInternationalTrade = (scenario) => {
    return scenario === '→IN Import to India (Abroad → India)' ||
           scenario === 'IN→ Export from India (India → Abroad)' ||
           scenario === 'Third Country (Abroad → Abroad)';
  };

  // Helper function to get payment term label
  const getPaymentTermLabel = (paymentTermValue) => {
    if (!paymentTermValue) return 'Not specified';
    
    // Hardcoded payment terms options (since edit page doesn't use master data)
    const paymentTermsOptions = [
      'Net 15',
      'Net 30',
      '30 days from delivery',
      '45 days from delivery',
      '60 days from delivery'
    ];
    
    // Try exact match (case-insensitive)
    const matched = paymentTermsOptions.find(term => 
      term.toLowerCase() === String(paymentTermValue).toLowerCase()
    );
    
    if (matched) {
      return matched;
    }
    
    // Fallback: return the value as-is
    return paymentTermValue;
  };

  // Helper function to get delivery term label
  const getDeliveryTermLabel = (deliveryTermValue) => {
    if (!deliveryTermValue) return 'Not specified';
    
    // Valid delivery term options
    const validDeliveryTerms = ['Ex-Works', 'Door Delivery', 'Port Delivery', 'Warehouse Pickup'];
    
    // Try exact match (case-insensitive)
    const matched = validDeliveryTerms.find(term => 
      term.toLowerCase() === String(deliveryTermValue).toLowerCase()
    );
    
    if (matched) {
      return matched;
    }
    
    // Fallback: return the value as-is
    return deliveryTermValue;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'tradeScenario') {
      if (value === 'IN Inter-State (Between Indian States)') {
        setFormData(prev => ({
          ...prev,
          tradeScenario: value,
          tradeType: 'Inter-State Trade (IGST)',
          tradeLocation: 'Karnataka ↔ Haryana'
        }));
      } else if (value === '→IN Import to India (Abroad → India)') {
        setFormData(prev => ({
          ...prev,
          tradeScenario: value,
          tradeType: 'Import: CIF + BCD + SWS + IGST',
          tradeLocation: 'United States → India'
        }));
      } else if (value === 'IN→ Export from India (India → Abroad)') {
        setFormData(prev => ({
          ...prev,
          tradeScenario: value,
          tradeType: 'Export: 0% IGST (with LUT)',
          tradeLocation: 'India → Germany'
        }));
      } else if (value === 'Third Country (Abroad → Abroad)') {
        setFormData(prev => ({
          ...prev,
          tradeScenario: value,
          tradeType: 'Third Country Trade',
          tradeLocation: 'United States → Singapore'
        }));
      } else {
        // IN Intra-State (Same State in India)
        setFormData(prev => ({
          ...prev,
          tradeScenario: value,
          tradeType: 'Intra-State Trade (CGST + SGST)',
          tradeLocation: 'Karnataka -> Karnataka'
        }));
      }
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleLineItemChange = (id, field, value) => {
    setLineItems(prev => prev.map(item => {
      if (item.id === id) {
        const updated = { ...item, [field]: parseFloat(value) || 0 };
        // Recalculate total
        const subtotal = updated.quantity * updated.unitPrice;
        const discountAmount = subtotal * (updated.discount / 100);
        const taxableAmount = subtotal - discountAmount;
        const cgstAmount = taxableAmount * (updated.cgst / 100);
        const sgstAmount = taxableAmount * (updated.sgst / 100);
        const igstAmount = taxableAmount * (updated.igst / 100);
        const cessAmount = taxableAmount * (updated.cess / 100);
        
        // Calculate total based on trade scenario
        if (formData.tradeScenario === 'Third Country (Abroad → Abroad)') {
          const taxAmount = taxableAmount * ((updated.tax || 0) / 100);
          updated.total = taxableAmount + taxAmount;
        } else if (isInternationalTrade(formData.tradeScenario)) {
          // For International: CIF value + Customs Duty + IGST + CESS
          const customsDutyAmount = taxableAmount * (updated.customsDuty / 100);
          const assessableValue = taxableAmount + customsDutyAmount;
          const igstOnAssessable = assessableValue * (updated.igst / 100);
          const cessOnAssessable = assessableValue * (updated.cess / 100);
          updated.total = assessableValue + igstOnAssessable + cessOnAssessable;
        } else if (formData.tradeScenario === 'IN Inter-State (Between Indian States)') {
          updated.total = taxableAmount + igstAmount + cessAmount;
        } else {
          updated.total = taxableAmount + cgstAmount + sgstAmount + cessAmount;
        }
        return updated;
      }
      return item;
    }));
  };

  // Recalculate all line items when trade scenario changes
  useEffect(() => {
    setLineItems(prev => prev.map(item => {
      const subtotal = item.quantity * item.unitPrice;
      const discountAmount = subtotal * (item.discount / 100);
      const taxableAmount = subtotal - discountAmount;
      const cgstAmount = taxableAmount * (item.cgst / 100);
      const sgstAmount = taxableAmount * (item.sgst / 100);
      const igstAmount = taxableAmount * (item.igst / 100);
      const cessAmount = taxableAmount * (item.cess / 100);
      
      // Calculate total based on trade scenario
      if (formData.tradeScenario === 'Third Country (Abroad → Abroad)') {
        const taxAmount = taxableAmount * ((item.tax || 0) / 100);
        return { ...item, total: taxableAmount + taxAmount };
      } else if (formData.tradeScenario === 'IN→ Export from India (India → Abroad)') {
        // For export: IGST and CESS are calculated on FOB Value (taxableAmount)
        if (formData.exportType === 'Non-LUT - IGST Applicable') {
          return { ...item, total: taxableAmount + igstAmount + cessAmount };
        } else {
          // LUT: No tax
          return { ...item, total: taxableAmount };
        }
      } else if (isInternationalTrade(formData.tradeScenario)) {
        const customsDutyAmount = taxableAmount * (item.customsDuty / 100);
        const assessableValue = taxableAmount + customsDutyAmount;
        const igstOnAssessable = assessableValue * (item.igst / 100);
        const cessOnAssessable = assessableValue * (item.cess / 100);
        return { ...item, total: assessableValue + igstOnAssessable + cessOnAssessable };
      } else if (formData.tradeScenario === 'IN Inter-State (Between Indian States)') {
        return { ...item, total: taxableAmount + igstAmount + cessAmount };
      } else {
        return { ...item, total: taxableAmount + cgstAmount + sgstAmount + cessAmount };
      }
    }));
  }, [formData.tradeScenario, formData.exportType]);

  // Set IGST and CESS to 0 when LUT is selected for export
  useEffect(() => {
    if (formData.tradeScenario === 'IN→ Export from India (India → Abroad)' && 
        formData.exportType === 'LUT (Letter of Undertaking) - 0% IGST') {
      setLineItems(prev => prev.map(item => ({
        ...item,
        igst: 0,
        cess: 0
      })));
    }
  }, [formData.exportType, formData.tradeScenario]);

  const handleDeleteLineItem = (id) => {
    setLineItems(prev => prev.filter(item => item.id !== id));
  };

  const handleAddLineItem = () => {
      const newId = Math.max(...lineItems.map(item => item.id), 0) + 1;
    setLineItems(prev => [...prev, {
      id: newId,
      description: '',
      hsn: '',
      quantity: 0,
      uom: 'pcs',
      unitPrice: 0,
      discount: 0,
      cgst: 9,
      sgst: 9,
      igst: 18,
      customsDuty: 10,
      cess: 0,
      total: 0
    }]);
  };

  const handleDeleteDeliverySchedule = (id) => {
    setDeliverySchedules(prev => prev.filter(item => item.id !== id));
  };

  const handleAddDeliverySchedule = () => {
    const newId = Math.max(...deliverySchedules.map(item => item.id), 0) + 1;
    setDeliverySchedules(prev => [...prev, {
      id: newId,
      item: lineItems.length > 0 ? lineItems[0].id : '',
      quantity: 0,
      deliveryDate: '',
      location: ''
    }]);
  };

  const handleDeleteTerm = (id) => {
    setTermsConditions(prev => prev.filter(item => item.id !== id));
  };

  const handleAddTerm = () => {
    const newId = Math.max(...termsConditions.map(item => item.id), 0) + 1;
    setTermsConditions(prev => [...prev, { id: newId, text: '' }]);
  };

  const handleTermChange = (id, value) => {
    setTermsConditions(prev => prev.map(term => 
      term.id === id ? { ...term, text: value } : term
    ));
  };

  const handleSpecialInstructionsChange = (e) => {
    setSpecialInstructions(e.target.value);
  };

  const handleDeleteAttachment = (id) => {
    setAttachments(prev => prev.filter(item => item.id !== id));
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    const newAttachments = files.map((file, index) => ({
      id: Math.max(...attachments.map(item => item.id), 0) + index + 1,
      name: file.name
    }));
    setAttachments(prev => [...prev, ...newAttachments]);
  };

  const calculateTotals = () => {
    const subtotal = lineItems.reduce((sum, item) => {
      const quantity = parseFloat(item.quantity) || 0;
      const unitPrice = parseFloat(item.unitPrice) || 0;
      return sum + (quantity * unitPrice);
    }, 0);

    const totalDiscount = lineItems.reduce((sum, item) => {
      const itemSubtotal = item.quantity * item.unitPrice;
      return sum + (itemSubtotal * (item.discount / 100));
    }, 0);

    const taxableAmount = subtotal - totalDiscount;
    const cgst = lineItems.reduce((sum, item) => {
      const itemSubtotal = item.quantity * item.unitPrice;
      const discountAmount = itemSubtotal * (item.discount / 100);
      const itemTaxable = itemSubtotal - discountAmount;
      return sum + (itemTaxable * (item.cgst / 100));
    }, 0);

    const sgst = lineItems.reduce((sum, item) => {
      const itemSubtotal = item.quantity * item.unitPrice;
      const discountAmount = itemSubtotal * (item.discount / 100);
      const itemTaxable = itemSubtotal - discountAmount;
      return sum + (itemTaxable * (item.sgst / 100));
    }, 0);

    const igst = lineItems.reduce((sum, item) => {
      const itemSubtotal = item.quantity * item.unitPrice;
      const discountAmount = itemSubtotal * (item.discount / 100);
      const itemTaxable = itemSubtotal - discountAmount;
      return sum + (itemTaxable * (item.igst / 100));
    }, 0);

    const cess = lineItems.reduce((sum, item) => {
      const itemSubtotal = item.quantity * item.unitPrice;
      const discountAmount = itemSubtotal * (item.discount / 100);
      const itemTaxable = itemSubtotal - discountAmount;
      return sum + (itemTaxable * (item.cess / 100));
    }, 0);

    // Calculate FOB and CIF for import scenarios
    const fobValue = taxableAmount; // FOB = Subtotal - Discount
    const cifValue = isInternationalTrade(formData.tradeScenario)
      ? fobValue + internationalCharges.shippingCharges + internationalCharges.insuranceCharges + internationalCharges.handlingCharges
      : 0;

    // International-specific calculations
    // BCD is calculated on CIF value, not FOB
    // For import: BCD = CIF × Customs Duty % (using average customs duty rate)
    const basicCustomsDuty = isInternationalTrade(formData.tradeScenario)
      ? (() => {
          // Calculate average customs duty rate from line items
          const totalFOB = lineItems.reduce((sum, item) => {
            const itemSubtotal = item.quantity * item.unitPrice;
            const discountAmount = itemSubtotal * (item.discount / 100);
            return sum + (itemSubtotal - discountAmount);
          }, 0);
          const weightedCustomsRate = lineItems.reduce((sum, item) => {
            const itemSubtotal = item.quantity * item.unitPrice;
            const discountAmount = itemSubtotal * (item.discount / 100);
            const itemFOB = itemSubtotal - discountAmount;
            return sum + ((itemFOB / totalFOB) * (item.customsDuty / 100));
          }, 0);
          return cifValue * weightedCustomsRate;
        })()
      : lineItems.reduce((sum, item) => {
          const itemSubtotal = item.quantity * item.unitPrice;
          const discountAmount = itemSubtotal * (item.discount / 100);
          const itemTaxable = itemSubtotal - discountAmount;
          return sum + (itemTaxable * (item.customsDuty / 100));
        }, 0);

    const socialWelfareSurcharge = basicCustomsDuty * 0.10; // 10% of BCD
    const assessableValue = isInternationalTrade(formData.tradeScenario)
      ? cifValue + basicCustomsDuty + socialWelfareSurcharge
      : taxableAmount + basicCustomsDuty + socialWelfareSurcharge;
    
    // IGST on Assessable Value for International
    const igstOnAssessable = isInternationalTrade(formData.tradeScenario)
      ? assessableValue * 0.18 // 18% IGST on assessable value
      : igst;

    // Calculate tax for Third Country scenario
    const tax = formData.tradeScenario === 'Third Country (Abroad → Abroad)'
      ? lineItems.reduce((sum, item) => {
          const itemSubtotal = item.quantity * item.unitPrice;
          const discountAmount = itemSubtotal * (item.discount / 100);
          const itemTaxable = itemSubtotal - discountAmount;
          return sum + (itemTaxable * ((item.tax || 0) / 100));
        }, 0)
      : 0;

    // Calculate grand total based on trade scenario
    let grandTotal;
    if (formData.tradeScenario === 'Third Country (Abroad → Abroad)') {
      grandTotal = taxableAmount + tax;
    } else if (formData.tradeScenario === 'IN→ Export from India (India → Abroad)') {
      // For export: IGST and CESS are calculated on FOB Value
      if (formData.exportType === 'Non-LUT - IGST Applicable') {
        grandTotal = taxableAmount + igst + cess;
      } else {
        // LUT: No tax
        grandTotal = taxableAmount;
      }
    } else if (isInternationalTrade(formData.tradeScenario)) {
      grandTotal = assessableValue + igstOnAssessable;
    } else if (formData.tradeScenario === 'IN Inter-State (Between Indian States)') {
      grandTotal = taxableAmount + igst + cess;
    } else {
      grandTotal = taxableAmount + cgst + sgst + cess;
    }

    return {
      subtotal,
      totalDiscount,
      taxableAmount,
      cgst,
      sgst,
      igst,
      igstOnAssessable,
      cess,
      tax,
      basicCustomsDuty,
      socialWelfareSurcharge,
      assessableValue,
      grandTotal,
      fobValue,
      cifValue
    };
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  const totals = calculateTotals();

  // Calculate international charges based on CIF config and FOB value
  useEffect(() => {
    if (isInternationalTrade(formData.tradeScenario)) {
      const fobValue = totals.taxableAmount;
      const shippingCharges = fobValue * (cifConfig.freightPercent / 100);
      const insuranceCharges = fobValue * (cifConfig.insurancePercent / 100);
      
      setInternationalCharges({
        shippingCharges: shippingCharges,
        insuranceCharges: insuranceCharges,
        handlingCharges: cifConfig.handlingFixed
      });
    }
  }, [cifConfig, totals.taxableAmount, formData.tradeScenario]);

  const handleCifConfigChange = (field, value) => {
    setCifConfig(prev => ({
      ...prev,
      [field]: parseFloat(value) || 0
    }));
  };

  const handleSaveDraft = () => {
    console.log('Saving as draft...', formData);
    // Implement save draft logic
  };

  const handlePreview = () => {
    setShowPreviewModal(true);
  };

  const handleSubmit = () => {
    console.log('Submitting PO...', formData);
    // Navigate to PO status tracking page after submission
    navigate('/po-status-tracking');
  };

  return (
    <div className="po-creation">
      <div className="po-main-content">
        {/* Header */}
        <div className="po-header">
          {/* Breadcrumb and Buttons Row */}
          <div className="po-header-top-row">
            <nav aria-label="breadcrumb" className="po-breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a 
                    href="#" 
                    className="breadcrumb-link" 
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/purchase-order-list');
                    }}
                  >
                    Order Details
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Edit Purchase Order
                </li>
              </ol>
            </nav>
            <div className="po-header-buttons">
              <button className="po-back-btn" onClick={() => navigate(-1)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m12 19-7-7 7-7"></path>
                  <path d="M19 12H5"></path>
                </svg>
                Back
              </button>
              <button className="po-btn-secondary" onClick={handleSaveDraft}>
                Save as Draft
              </button>
              <button className="po-btn-primary" onClick={handlePreview}>
                Preview & Update Purchase Order
              </button>
            </div>
          </div>
          
          {/* Title and Trade Scenario Row */}
          <div className="po-header-content-row">
            <div className="po-header-left">
              <h1 className="po-main-title">Edit Purchase Order</h1>
              <p className="po-subtitle">
                Edit and update purchase order based on approved quotation {quotationData.quotationId}
              </p>
            </div>
            <div className="po-header-right">
              <div className="po-trade-scenario-wrapper">
                <div className="po-trade-scenario">
                  <label className="po-trade-scenario-label">Trade Scenario:</label>
                  <select 
                    className="po-trade-scenario-select"
                    value={formData.tradeScenario}
                    onChange={handleInputChange}
                    name="tradeScenario"
                    readOnly
                    disabled
                    style={{ cursor: 'not-allowed', opacity: 0.7 }}
                  >
                    <option>IN Intra-State (Same State in India)</option>
                    <option>IN Inter-State (Between Indian States)</option>
                    <option>→IN Import to India (Abroad → India)</option>
                    <option>IN→ Export from India (India → Abroad)</option>
                    <option>Third Country (Abroad → Abroad)</option>
                  </select>
                </div>
                <div className="po-trade-type-badge">
                  <span className="po-badge">{formData.tradeType}</span>
                </div>
                <div className="po-trade-location">
                  {formData.tradeLocation}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Reference Quotation Card */}
        <div className="po-reference-quotation-card">
          <div className="po-reference-quotation-header">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="po-reference-icon">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10 9 9 9 8 9"></polyline>
            </svg>
            <h3 className="po-section-title">Reference Quotation</h3>
          </div>
          <div className="po-reference-quotation-content">
            {/* First Row - 4 Columns */}
            <div className="po-reference-quotation-row po-reference-quotation-row-first">
              <div className="po-reference-quotation-item">
                <label>Quotation ID</label>
                <p className="po-reference-value">{quotationData.quotationId}</p>
              </div>
              <div className="po-reference-quotation-item">
                <label>Linked RFQ</label>
                <p className="po-reference-value">{quotationData.linkedRFQ}</p>
              </div>
              <div className="po-reference-quotation-item">
                <label>Quote Date</label>
                <p className="po-reference-value">{quotationData.quoteDate}</p>
              </div>
              <div className="po-reference-quotation-item">
                <label>Valid Until</label>
                <p className="po-reference-value">{quotationData.validUntil}</p>
              </div>
            </div>
            
            {/* Horizontal Line */}
            <div className="po-reference-quotation-divider"></div>
            
            {/* Second Row - 4 Columns */}
            <div className="po-reference-quotation-row po-reference-quotation-row-second">
              <div className="po-reference-quotation-item">
                <label>Seller Company</label>
                <p className="po-reference-value">{quotationData.sellerCompany}</p>
              </div>
              <div className="po-reference-quotation-item">
                <label>Contact Person</label>
                <p className="po-reference-value">{quotationData.contactPerson}</p>
              </div>
              <div className="po-reference-quotation-item">
                <label>Contact Email</label>
                <p className="po-reference-value">{quotationData.contactEmail}</p>
              </div>
              <div className="po-reference-quotation-item">
                <label>Contact Phone</label>
                <p className="po-reference-value">{quotationData.contactPhone}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Purchase Order Details Card */}
        <div className="po-purchase-order-details-section">
          <h3 className="po-section-title">Purchase Order Details <span className="po-section-subtitle-inline">(Fill in the PO header information)</span></h3>
          <div className="po-purchase-order-details-content">
            <div className="po-form-grid">
              <div className="po-form-field">
                <label>PO Number</label>
                <input 
                  type="text" 
                  className="po-input" 
                  value={formData.poNumber}
                  readOnly
                />
                <span className="po-input-hint">Auto-generated</span>
              </div>
              <div className="po-form-field">
                <label>PO Date <span className="po-required">*</span></label>
                <input 
                  type="date" 
                  className="po-input po-input-date" 
                  name="poDate"
                  value={formData.poDate}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="po-form-field">
                <label>Expected Delivery Date <span className="po-required">*</span></label>
                <input 
                  type="date" 
                  className="po-input po-input-date" 
                  name="expectedDeliveryDate"
                  value={formData.expectedDeliveryDate}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="po-form-field">
                <label>Priority Level</label>
                <select 
                  className="po-input po-input-select"
                  name="priorityLevel"
                  value={formData.priorityLevel}
                  onChange={handleInputChange}
                >
                  <option>Low</option>
                  <option>Normal</option>
                  <option>High</option>
                  <option>Urgent</option>
                </select>
              </div>
            </div>
            
            {/* Divider */}
            <div className="po-reference-quotation-divider"></div>
            
            <div className="po-form-grid">
              <div className="po-form-field">
                <select 
                  className="po-input po-input-select"
                  name="paymentTerms"
                  value={formData.paymentTerms}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Payment Terms</option>
                  <option>Net 15</option>
                  <option>Net 30</option>
                  <option>30 days from delivery</option>
                  <option>45 days from delivery</option>
                  <option>60 days from delivery</option>
                </select>
              </div>
              <div className="po-form-field">
                <select 
                  className="po-input po-input-select"
                  name="currency"
                  value={formData.currency}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Currency</option>
                  <option value="INR">INR - Indian Rupee</option>
                  <option value="USD">USD - US Dollar</option>
                  <option value="EUR">EUR - Euro</option>
                  <option value="GBP">GBP - British Pound</option>
                  <option value="JPY">JPY - Japanese Yen</option>
                  <option value="CNY">CNY - Chinese Yuan</option>
                  <option value="AUD">AUD - Australian Dollar</option>
                  <option value="CAD">CAD - Canadian Dollar</option>
                  <option value="SGD">SGD - Singapore Dollar</option>
                  <option value="AED">AED - UAE Dirham</option>
                </select>
              </div>
              <div className="po-form-field">
                <label>Freight Terms</label>
                <select 
                  className="po-input po-input-select"
                  name="freightTerms"
                  value={formData.freightTerms}
                  onChange={handleInputChange}
                >
                  <option value="">Select Freight Terms</option>
                  <option>FOB (Free on Board)</option>
                  <option>CIF (Cost, Insurance and Freight)</option>
                  <option>EXW (Ex Works)</option>
                  <option>DDP (Delivered Duty Paid)</option>
                </select>
              </div>
              <div className="po-form-field">
                <label>Delivery Terms</label>
                <select 
                  className="po-input po-input-select"
                  name="deliveryTerms"
                  value={formData.deliveryTerms}
                  onChange={handleInputChange}
                >
                  <option value="">Select Delivery Terms</option>
                  <option value="Ex-Works">Ex-Works</option>
                  <option value="Door Delivery">Door Delivery</option>
                  <option value="Port Delivery">Port Delivery</option>
                  <option value="Warehouse Pickup">Warehouse Pickup</option>
                </select>
              </div>
            </div>
            
            {/* Divider */}
            <div className="po-reference-quotation-divider"></div>
            
            {/* International Trade Details - Conditional */}
            {isInternationalTrade(formData.tradeScenario) && (
              <div className="po-international-trade-section">
                <div className="po-international-trade-header">
                  <h3 className="po-international-trade-title">
                    <span className="po-international-trade-title-text">International Trade Details</span>
                  </h3>
                  <span className={`po-trade-badge ${
                    formData.tradeScenario === 'IN→ Export from India (India → Abroad)' 
                      ? 'po-export-badge' 
                      : formData.tradeScenario === 'Third Country (Abroad → Abroad)'
                      ? 'po-third-country-badge'
                      : 'po-import-badge'
                  }`}>
                    {formData.tradeScenario === 'IN→ Export from India (India → Abroad)' 
                      ? 'Export' 
                      : formData.tradeScenario === 'Third Country (Abroad → Abroad)'
                      ? 'Third Country'
                      : 'Import'}
                  </span>
                </div>
                <div className="po-international-trade-grid">
                  <div className="po-form-field">
                    <label htmlFor="portOfLoading" className="po-form-label">Port of Loading</label>
                    <input
                      type="text"
                      id="portOfLoading"
                      className="po-input"
                      name="portOfLoading"
                      value={formData.portOfLoading || ''}
                      onChange={handleInputChange}
                      placeholder="Origin port"
                    />
                  </div>
                  <div className="po-form-field">
                    <label htmlFor="portOfDischarge" className="po-form-label">Port of Discharge</label>
                    <input
                      type="text"
                      id="portOfDischarge"
                      className="po-input"
                      name="portOfDischarge"
                      value={formData.portOfDischarge || ''}
                      onChange={handleInputChange}
                      placeholder="Destination port"
                    />
                  </div>
                  <div className="po-form-field">
                    <label htmlFor="customsBroker" className="po-form-label">Customs Broker/CHA</label>
                    <input
                      type="text"
                      id="customsBroker"
                      className="po-input"
                      name="customsBroker"
                      value={formData.customsBroker || ''}
                      onChange={handleInputChange}
                      placeholder="Customs handling agent"
                    />
                  </div>
                  <div className="po-form-field">
                    <label htmlFor="hsCode" className="po-form-label">HS Code (Harmonized System)</label>
                    <input
                      type="text"
                      id="hsCode"
                      className="po-input"
                      name="hsCode"
                      value={formData.hsCode || ''}
                      onChange={handleInputChange}
                      placeholder="8-digit HS code"
                    />
                  </div>
                  <div className="po-form-field">
                    <label htmlFor="countryOfOrigin" className="po-form-label">Country of Origin</label>
                    <input
                      type="text"
                      id="countryOfOrigin"
                      className="po-input"
                      name="countryOfOrigin"
                      value={formData.countryOfOrigin || ''}
                      onChange={handleInputChange}
                      placeholder="Manufacturing country"
                    />
                  </div>
                  <div className="po-form-field">
                    <label htmlFor="incoterms" className="po-form-label">Incoterms</label>
                    <select
                      id="incoterms"
                      className="po-input po-input-select"
                      name="incoterms"
                      value={formData.incoterms || ''}
                      onChange={handleInputChange}
                    >
                      <option value="">Select Incoterms</option>
                      <option>FOB - Free on Board</option>
                      <option>CIF - Cost, Insurance and Freight</option>
                      <option>EXW - Ex Works</option>
                      <option>DDP - Delivered Duty Paid</option>
                      <option>CFR - Cost and Freight</option>
                    </select>
                  </div>
                </div>
                
                {/* Export Tax Treatment - Only for Export scenarios */}
                {formData.tradeScenario === 'IN→ Export from India (India → Abroad)' && (
                  <div className="po-export-tax-treatment">
                    <h4 className="po-export-tax-title">Export Tax Treatment</h4>
                    <div className="po-export-tax-grid">
                      <div className="po-form-field">
                        <label htmlFor="exportType" className="po-form-label">Export Type *</label>
                        <select
                          id="exportType"
                          className="po-input po-input-select"
                          name="exportType"
                          value={formData.exportType || ''}
                          onChange={handleInputChange}
                        >
                          <option value="LUT (Letter of Undertaking) - 0% IGST">LUT (Letter of Undertaking) - 0% IGST</option>
                          <option value="Non-LUT - IGST Applicable">Non-LUT - IGST Applicable</option>
                        </select>
                      </div>
                      {formData.exportType === 'LUT (Letter of Undertaking) - 0% IGST' && (
                        <div className="po-form-field po-form-field-wide">
                          <label htmlFor="lutArn" className="po-form-label">ARN Number (Application Reference Number) *</label>
                          <input
                            type="text"
                            id="lutArn"
                            className="po-input"
                            name="lutArn"
                            value={formData.lutArn || ''}
                            onChange={handleInputChange}
                            placeholder="AA341234567890Z"
                          />
                          <p className="po-form-hint">ARN for LUT approved by GST department</p>
                        </div>
                      )}
                      {formData.exportType === 'Non-LUT - IGST Applicable' && (
                        <div className="po-form-field po-form-field-wide">
                          <div className="po-export-warning-box">
                            <p className="po-export-warning-text">⚠️ IGST will be charged on FOB value. Refund can be claimed after export with shipping bills.</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                
                <div className="po-required-documents-box">
                  <p className="po-required-documents-text">
                    <strong>Required Documents:</strong> Commercial Invoice, Packing List, Bill of Lading/Airway Bill, Certificate of Origin, Insurance Certificate, Bill of Entry, Import License (if applicable)
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Buyer & Seller Details Cards */}
        <div className="po-details-grid">
          <div className="po-purchase-order-details-section">
            <div className="po-reference-quotation-header">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="po-reference-icon">
                <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path>
                <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path>
                <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path>
                <path d="M10 6h4"></path>
                <path d="M10 10h4"></path>
                <path d="M10 14h4"></path>
                <path d="M10 18h4"></path>
              </svg>
              <h3 className="po-section-title">Buyer Details</h3>
            </div>
            <div className="po-purchase-order-details-content">
              <div className="po-details-list">
                <div className="po-detail-item">
                  <label>Company Name</label>
                  <div className="po-detail-value">{buyerDetails.companyName}</div>
                </div>
                <div className="po-detail-item">
                  <label>Address</label>
                  <input 
                    type="text" 
                    className="po-detail-input" 
                    name="buyerAddress"
                    value={formData.buyerAddress}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="po-detail-item">
                  <label>GST Number</label>
                  <input 
                    type="text" 
                    className="po-detail-input" 
                    name="buyerGstNumber"
                    value={formData.buyerGstNumber}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="po-detail-item po-detail-item-row">
                  <div className="po-detail-item-half">
                    <label>Country</label>
                    <select
                      className="po-detail-input po-input-select"
                      name="buyerCountry"
                      value={formData.buyerCountry}
                      onChange={handleInputChange}
                    >
                      <option value="">Select Country</option>
                      {countryOptions.map((country, index) => (
                        <option key={index} value={country}>
                          {country}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="po-detail-item-half">
                    <label>State</label>
                    <select
                      className="po-detail-input po-input-select"
                      name="buyerState"
                      value={formData.buyerState}
                      onChange={handleInputChange}
                    >
                      <option value="">Select State</option>
                      {stateOptions.map((state, index) => (
                        <option key={index} value={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="po-detail-item po-detail-item-row-3">
                  <div className="po-detail-item-third">
                    <label>Contact Person</label>
                    <div className="po-detail-value">{buyerDetails.contactPerson}</div>
                  </div>
                  <div className="po-detail-item-third">
                    <label>Email</label>
                    <div className="po-detail-value">{buyerDetails.email}</div>
                  </div>
                  <div className="po-detail-item-third">
                    <label>Phone</label>
                    <div className="po-detail-value">{buyerDetails.phone}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="po-reference-quotation-card">
            <div className="po-reference-quotation-header">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="po-reference-icon">
                <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path>
                <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path>
                <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path>
                <path d="M10 6h4"></path>
                <path d="M10 10h4"></path>
                <path d="M10 14h4"></path>
                <path d="M10 18h4"></path>
              </svg>
              <h3 className="po-section-title">Seller/Vendor Details</h3>
            </div>
            <div className="po-purchase-order-details-content">
              <div className="po-details-list">
                <div className="po-detail-item">
                  <label>Company Name</label>
                  <div className="po-detail-value">{sellerDetails.companyName}</div>
                </div>
                <div className="po-detail-item">
                  <label>Address</label>
                  <input 
                    type="text" 
                    className="po-detail-input" 
                    name="sellerAddress"
                    value={formData.sellerAddress}
                    onChange={handleInputChange}
                    disabled
                  />
                </div>
                <div className="po-detail-item">
                  <label>GST Number</label>
                  <input 
                    type="text" 
                    className="po-detail-input" 
                    name="sellerGstNumber"
                    value={formData.sellerGstNumber}
                    onChange={handleInputChange}
                    disabled
                  />
                </div>
                <div className="po-detail-item po-detail-item-row">
                  <div className="po-detail-item-half">
                    <label>Country</label>
                    <select
                      className="po-detail-input po-input-select"
                      name="sellerCountry"
                      value={formData.sellerCountry}
                      onChange={handleInputChange}
                      disabled
                    >
                      <option value="">Select Country</option>
                      {countryOptions.map((country, index) => (
                        <option key={index} value={country}>
                          {country}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="po-detail-item-half">
                    <label>State</label>
                    <select
                      className="po-detail-input po-input-select"
                      name="sellerState"
                      value={formData.sellerState}
                      onChange={handleInputChange}
                      disabled
                    >
                      <option value="">Select State</option>
                      {stateOptions.map((state, index) => (
                        <option key={index} value={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="po-detail-item po-detail-item-row-3">
                  <div className="po-detail-item-third">
                    <label>Contact Person</label>
                    <div className="po-detail-value">{sellerDetails.contactPerson}</div>
                  </div>
                  <div className="po-detail-item-third">
                    <label>Email</label>
                    <div className="po-detail-value">{sellerDetails.email}</div>
                  </div>
                  <div className="po-detail-item-third">
                    <label>Phone</label>
                    <div className="po-detail-value">{sellerDetails.phone}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CIF Value Configuration - Only for Import scenarios */}
        {formData.tradeScenario === '→IN Import to India (Abroad → India)' && (
          <div className="po-cif-config-card">
            <div className="po-cif-config-header">
              <h4 className="po-cif-config-title">CIF Value Configuration</h4>
              <p className="po-cif-config-subtitle">
                Configure freight, insurance, and handling charges to calculate CIF (Cost, Insurance, Freight) value
              </p>
            </div>
            <div className="po-cif-config-content">
              <div className="po-cif-config-grid">
                <div className="po-cif-config-field">
                  <label htmlFor="freightPercent" className="po-cif-config-label">
                    Freight Charges (%)
                  </label>
                  <input
                    type="number"
                    id="freightPercent"
                    className="po-cif-config-input"
                    step="0.1"
                    placeholder="% of FOB value"
                    value={cifConfig.freightPercent}
                    onChange={(e) => handleCifConfigChange('freightPercent', e.target.value)}
                  />
                  <p className="po-cif-config-hint">Percentage of FOB value</p>
                </div>
                <div className="po-cif-config-field">
                  <label htmlFor="insurancePercent" className="po-cif-config-label">
                    Insurance Charges (%)
                  </label>
                  <input
                    type="number"
                    id="insurancePercent"
                    className="po-cif-config-input"
                    step="0.1"
                    placeholder="% of FOB value"
                    value={cifConfig.insurancePercent}
                    onChange={(e) => handleCifConfigChange('insurancePercent', e.target.value)}
                  />
                  <p className="po-cif-config-hint">Percentage of FOB value</p>
                </div>
                <div className="po-cif-config-field">
                  <label htmlFor="handlingFixed" className="po-cif-config-label">
                    Handling & Clearance (₹)
                  </label>
                  <input
                    type="number"
                    id="handlingFixed"
                    className="po-cif-config-input"
                    placeholder="Fixed amount"
                    value={cifConfig.handlingFixed}
                    onChange={(e) => handleCifConfigChange('handlingFixed', e.target.value)}
                  />
                  <p className="po-cif-config-hint">Fixed amount in INR</p>
                </div>
              </div>
              <div className="po-cif-calculation-info">
                <p className="po-cif-calculation-title"><strong>CIF Calculation:</strong> FOB Value + Freight ({cifConfig.freightPercent}%) + Insurance ({cifConfig.insurancePercent}%) + Handling (₹{formatCurrency(cifConfig.handlingFixed)})</p>
                <p className="po-cif-calculation-note">As per Indian Customs law, Basic Customs Duty (BCD) and subsequent taxes are calculated on the CIF value, not FOB.</p>
              </div>
            </div>
          </div>
        )}

        {/* Line Items Card - Visible for all trade scenarios */}
        {(formData.tradeScenario === 'IN Intra-State (Same State in India)' || formData.tradeScenario === 'IN Inter-State (Between Indian States)' || isInternationalTrade(formData.tradeScenario)) && (
          <div className="po-line-items-card">
            <div className="po-line-items-header">
              <div className="po-line-items-header-left">
                <h4 className="po-line-items-title">
                  Line Items
                  {formData.tradeScenario === 'IN→ Export from India (India → Abroad)' && (
                    <span className="po-export-badge-inline">Export: IGST & CESS ✓</span>
                  )}
                </h4>
                <p className="po-line-items-subtitle">
                  Review and edit items from quotation. Add additional items like packaging, installation, or freight charges as needed
                </p>
              </div>
              <button className="po-btn-add-line-item" onClick={handleAddLineItem} type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="po-add-icon">
                  <path d="M5 12h14"></path>
                  <path d="M12 5v14"></path>
                </svg>
                Add Line Item
              </button>
            </div>
            <div className="po-line-items-content">
              <div className="po-table-wrapper">
                <table className="po-line-items-table">
                  <thead>
                    <tr>
                      <th className="po-table-col-number">#</th>
                      <th className="po-table-col-description">Description</th>
                      <th>HSN</th>
                      <th className="po-table-col-qty">Qty</th>
                      <th>UOM</th>
                      <th className="po-table-col-price">Unit Price (₹)</th>
                      <th className="po-table-col-disc">Disc %</th>
                      {isInternationalTrade(formData.tradeScenario) ? (
                        <>
                          {formData.tradeScenario === 'IN→ Export from India (India → Abroad)' ? (
                            <>
                              <th className="po-table-col-tax po-table-col-igst-export">IGST %</th>
                              <th className="po-table-col-tax po-table-col-cess-export">CESS %</th>
                            </>
                          ) : formData.tradeScenario === 'Third Country (Abroad → Abroad)' ? (
                            <>
                              <th className="po-table-col-tax">Tax %</th>
                            </>
                          ) : (
                            <>
                              <th className="po-table-col-tax">Customs %</th>
                              <th className="po-table-col-tax">IGST %</th>
                              <th className="po-table-col-tax">CESS %</th>
                            </>
                          )}
                        </>
                      ) : formData.tradeScenario === 'IN Inter-State (Between Indian States)' ? (
                        <>
                          <th className="po-table-col-tax">IGST %</th>
                          <th className="po-table-col-tax">CESS %</th>
                        </>
                      ) : (
                        <>
                          <th className="po-table-col-tax">CGST %</th>
                          <th className="po-table-col-tax">SGST %</th>
                          <th className="po-table-col-tax">CESS %</th>
                        </>
                      )}
                      <th>Total (₹)</th>
                      <th className="po-table-col-action">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lineItems.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>
                          <input 
                            type="text" 
                            className="po-table-input"
                            value={item.description}
                            onChange={(e) => handleLineItemChange(item.id, 'description', e.target.value)}
                          />
                        </td>
                        <td>
                          <input 
                            type="text" 
                            className="po-table-input po-table-input-hsn"
                            value={item.hsn}
                            onChange={(e) => handleLineItemChange(item.id, 'hsn', e.target.value)}
                          />
                        </td>
                        <td>
                          <input 
                            type="number" 
                            className="po-table-input po-table-input-number"
                            value={item.quantity}
                            onChange={(e) => handleLineItemChange(item.id, 'quantity', e.target.value)}
                          />
                        </td>
                        <td>
                          <select 
                            className="po-table-input po-table-input-select"
                            value={item.uom}
                            onChange={(e) => handleLineItemChange(item.id, 'uom', e.target.value)}
                          >
                            <option value="pcs">pcs</option>
                            <option value="units">units</option>
                            <option value="kg">kg</option>
                            <option value="m">m</option>
                            <option value="sqm">sqm</option>
                          </select>
                        </td>
                        <td>
                          <input 
                            type="number" 
                            className="po-table-input po-table-input-number"
                            value={item.unitPrice}
                            onChange={(e) => handleLineItemChange(item.id, 'unitPrice', e.target.value)}
                          />
                        </td>
                        <td>
                          <input 
                            type="number" 
                            className="po-table-input po-table-input-number"
                            value={item.discount}
                            onChange={(e) => handleLineItemChange(item.id, 'discount', e.target.value)}
                          />
                        </td>
                        {isInternationalTrade(formData.tradeScenario) ? (
                          <>
                            {formData.tradeScenario === 'IN→ Export from India (India → Abroad)' ? (
                              <>
                                <td>
                                  <input 
                                    type="number" 
                                    className="po-table-input po-table-input-number po-table-input-tax"
                                    value={formData.exportType === 'LUT (Letter of Undertaking) - 0% IGST' ? 0 : item.igst}
                                    onChange={(e) => handleLineItemChange(item.id, 'igst', e.target.value)}
                                    disabled={formData.exportType === 'LUT (Letter of Undertaking) - 0% IGST'}
                                    placeholder="0 (LUT)"
                                  />
                                </td>
                                <td>
                                  <input 
                                    type="number" 
                                    className="po-table-input po-table-input-number po-table-input-tax"
                                    value={formData.exportType === 'LUT (Letter of Undertaking) - 0% IGST' ? 0 : item.cess}
                                    onChange={(e) => handleLineItemChange(item.id, 'cess', e.target.value)}
                                    disabled={formData.exportType === 'LUT (Letter of Undertaking) - 0% IGST'}
                                    placeholder="0 (LUT)"
                                  />
                                </td>
                              </>
                            ) : formData.tradeScenario === 'Third Country (Abroad → Abroad)' ? (
                              <>
                                <td>
                                  <input 
                                    type="number" 
                                    className="po-table-input po-table-input-number po-table-input-tax"
                                    value={item.tax || 0}
                                    onChange={(e) => handleLineItemChange(item.id, 'tax', e.target.value)}
                                    placeholder="VAT/GST"
                                  />
                                </td>
                              </>
                            ) : (
                              <>
                                <td>
                                  <input 
                                    type="number" 
                                    className="po-table-input po-table-input-number po-table-input-tax"
                                    value={item.customsDuty || 0}
                                    onChange={(e) => handleLineItemChange(item.id, 'customsDuty', e.target.value)}
                                  />
                                </td>
                                <td>
                                  <input 
                                    type="number" 
                                    className="po-table-input po-table-input-number po-table-input-tax"
                                    value={item.igst}
                                    onChange={(e) => handleLineItemChange(item.id, 'igst', e.target.value)}
                                  />
                                </td>
                                <td>
                                  <input 
                                    type="number" 
                                    className="po-table-input po-table-input-number po-table-input-tax"
                                    value={item.cess}
                                    onChange={(e) => handleLineItemChange(item.id, 'cess', e.target.value)}
                                  />
                                </td>
                              </>
                            )}
                          </>
                        ) : formData.tradeScenario === 'IN Inter-State (Between Indian States)' ? (
                          <>
                            <td>
                              <input 
                                type="number" 
                                className="po-table-input po-table-input-number po-table-input-tax"
                                value={item.igst}
                                onChange={(e) => handleLineItemChange(item.id, 'igst', e.target.value)}
                              />
                            </td>
                            <td>
                              <input 
                                type="number" 
                                className="po-table-input po-table-input-number po-table-input-tax"
                                value={item.cess}
                                onChange={(e) => handleLineItemChange(item.id, 'cess', e.target.value)}
                              />
                            </td>
                          </>
                        ) : (
                          <>
                            <td>
                              <input 
                                type="number" 
                                className="po-table-input po-table-input-number po-table-input-tax"
                                value={item.cgst}
                                onChange={(e) => handleLineItemChange(item.id, 'cgst', e.target.value)}
                              />
                            </td>
                            <td>
                              <input 
                                type="number" 
                                className="po-table-input po-table-input-number po-table-input-tax"
                                value={item.sgst}
                                onChange={(e) => handleLineItemChange(item.id, 'sgst', e.target.value)}
                              />
                            </td>
                            <td>
                              <input 
                                type="number" 
                                className="po-table-input po-table-input-number po-table-input-tax"
                                value={item.cess}
                                onChange={(e) => handleLineItemChange(item.id, 'cess', e.target.value)}
                              />
                            </td>
                          </>
                        )}
                        <td>{formatCurrency(item.total)}</td>
                        <td>
                          <button 
                            className="po-btn-delete-item"
                            onClick={() => handleDeleteLineItem(item.id)}
                            type="button"
                            title="Remove item"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="po-delete-icon">
                              <path d="M10 11v6"></path>
                              <path d="M14 11v6"></path>
                              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path>
                              <path d="M3 6h18"></path>
                              <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                            </svg>
                          </button>
                        </td>
                      </tr>
                    ))}
                    {/* Summary Rows */}
                    {formData.tradeScenario === 'IN→ Export from India (India → Abroad)' ? (
                      <>
                        <tr className="po-table-summary-row">
                          <td colSpan="9" className="po-table-summary-label text-right">Subtotal (Qty × Unit Price):</td>
                          <td className="po-table-summary-value" colSpan="2">{formatCurrency(totals.subtotal)}</td>
                        </tr>
                        <tr className="po-table-summary-row">
                          <td colSpan="9" className="po-table-summary-label text-right">Total Discount:</td>
                          <td className="po-table-summary-value" colSpan="2">- {formatCurrency(totals.totalDiscount)}</td>
                        </tr>
                        <tr className="po-table-summary-row po-breakdown-blue">
                          <td colSpan="9" className="po-table-summary-label text-right">
                            <strong>FOB Value (Free on Board):</strong>
                          </td>
                          <td className="po-table-summary-value" colSpan="2">
                            <strong>{formatCurrency(totals.subtotal - totals.totalDiscount)}</strong>
                          </td>
                        </tr>
                        {formData.exportType === 'LUT (Letter of Undertaking) - 0% IGST' && (
                          <tr className="po-table-summary-row po-breakdown-green">
                            <td colSpan="9" className="po-table-summary-label text-right text-green-700">
                              <em>✓ Export with LUT (Letter of Undertaking) - 0% IGST</em><br />
                              <span className="text-xs">ARN: {formData.lutArn || 'AA341234567890Z'}</span>
                            </td>
                            <td className="po-table-summary-value text-right text-green-700" colSpan="2">
                              <em>No Tax</em>
                            </td>
                          </tr>
                        )}
                        {formData.exportType === 'Non-LUT - IGST Applicable' && (
                          <>
                            <tr className="po-table-summary-row">
                              <td colSpan="9" className="po-table-summary-label text-right">IGST:</td>
                              <td className="po-table-summary-value" colSpan="2">{formatCurrency(totals.igst)}</td>
                            </tr>
                            <tr className="po-table-summary-row">
                              <td colSpan="9" className="po-table-summary-label text-right">CESS:</td>
                              <td className="po-table-summary-value" colSpan="2">{formatCurrency(totals.cess)}</td>
                            </tr>
                            <tr className="po-table-summary-row po-breakdown-amber">
                              <td colSpan="9" className="po-table-summary-label text-right">
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#B45309' }}>
                                    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
                                    <path d="M12 9v4"></path>
                                    <path d="M12 17h.01"></path>
                                  </svg>
                                  Export without LUT - IGST Amount (Refundable):
                                </span>
                              </td>
                              <td className="po-table-summary-value" colSpan="2">{formatCurrency(totals.igst)}</td>
                            </tr>
                            <tr className="po-table-summary-row po-breakdown-amber">
                              <td colSpan="9" className="po-table-summary-label text-right">
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#B45309' }}>
                                    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
                                    <path d="M12 9v4"></path>
                                    <path d="M12 17h.01"></path>
                                  </svg>
                                  Export without LUT - CESS Amount (Refundable):
                                </span>
                              </td>
                              <td className="po-table-summary-value" colSpan="2">{formatCurrency(totals.cess)}</td>
                            </tr>
                          </>
                        )}
                      </>
                    ) : formData.tradeScenario === 'Third Country (Abroad → Abroad)' ? (
                      <>
                        <tr className="po-table-summary-row">
                          <td colSpan="8" className="po-table-summary-label text-right">Subtotal (Qty × Unit Price):</td>
                          <td className="po-table-summary-value" colSpan="2">{formatCurrency(totals.subtotal)}</td>
                        </tr>
                        <tr className="po-table-summary-row">
                          <td colSpan="8" className="po-table-summary-label text-right">Total Discount:</td>
                          <td className="po-table-summary-value" colSpan="2">- {formatCurrency(totals.totalDiscount)}</td>
                        </tr>
                        <tr className="po-table-summary-row po-breakdown-blue">
                          <td colSpan="8" className="po-table-summary-label text-right">
                            <strong>FOB Value (Free on Board):</strong>
                          </td>
                          <td className="po-table-summary-value" colSpan="2">
                            <strong>{formatCurrency(totals.subtotal - totals.totalDiscount)}</strong>
                          </td>
                        </tr>
                      </>
                    ) : formData.tradeScenario !== '→IN Import to India (Abroad → India)' ? (
                      <>
                        <tr className="po-table-summary-row">
                          <td colSpan={formData.tradeScenario === 'IN Inter-State (Between Indian States)' ? "9" : "10"} className="po-table-summary-label">Subtotal (Qty × Unit Price):</td>
                          <td className="po-table-summary-value" colSpan="2">{formatCurrency(totals.subtotal)}</td>
                        </tr>
                        <tr className="po-table-summary-row">
                          <td colSpan={formData.tradeScenario === 'IN Inter-State (Between Indian States)' ? "9" : "10"} className="po-table-summary-label">Total Discount:</td>
                          <td className="po-table-summary-value" colSpan="2">- {formatCurrency(totals.totalDiscount)}</td>
                        </tr>
                        <tr className="po-table-summary-row">
                          <td colSpan={formData.tradeScenario === 'IN Inter-State (Between Indian States)' ? "9" : "10"} className="po-table-summary-label"><strong>Taxable Amount:</strong></td>
                          <td className="po-table-summary-value" colSpan="2"><strong>{formatCurrency(totals.taxableAmount)}</strong></td>
                        </tr>
                      </>
                    ) : null}
                          {formData.tradeScenario === '→IN Import to India (Abroad → India)' ? (
                      <>
                        <tr className="po-table-summary-row po-table-landed-cost">
                          <td colSpan="10" className="po-table-summary-label text-right">
                            <strong>Sum of All Line Items (Landed Cost):</strong>
                          </td>
                          <td className="po-table-summary-value" colSpan="2">
                            <strong>{formatCurrency(totals.grandTotal)}</strong>
                          </td>
                        </tr>
                        {/* Detailed Breakdown in Table */}
                        <tr className="po-table-breakdown-divider">
                          <td colSpan="13" className="po-table-summary-label text-center text-xs italic py-2">
                            ──── Detailed Breakdown Below (For Reference Only) ────
                          </td>
                        </tr>
                        <tr className="po-table-breakdown-row po-breakdown-gray">
                          <td colSpan="10" className="po-table-summary-label text-right">Subtotal (Qty × Unit Price):</td>
                          <td className="po-table-summary-value" colSpan="2">{formatCurrency(totals.subtotal)}</td>
                        </tr>
                        <tr className="po-table-breakdown-row po-breakdown-gray">
                          <td colSpan="10" className="po-table-summary-label text-right">Total Discount:</td>
                          <td className="po-table-summary-value" colSpan="2">- {formatCurrency(totals.totalDiscount)}</td>
                        </tr>
                        <tr className="po-table-breakdown-row po-breakdown-blue">
                          <td colSpan="10" className="po-table-summary-label text-right">
                            <strong>FOB Value (Free on Board):</strong>
                          </td>
                          <td className="po-table-summary-value" colSpan="2">
                            <strong>{formatCurrency(totals.fobValue)}</strong>
                          </td>
                        </tr>
                        <tr className="po-table-breakdown-row po-breakdown-amber">
                          <td colSpan="10" className="po-table-summary-label text-right">+ Freight Charges ({cifConfig.freightPercent}% of FOB):</td>
                          <td className="po-table-summary-value" colSpan="2">{formatCurrency(internationalCharges.shippingCharges)}</td>
                        </tr>
                        <tr className="po-table-breakdown-row po-breakdown-amber">
                          <td colSpan="10" className="po-table-summary-label text-right">+ Insurance Charges ({cifConfig.insurancePercent}% of FOB):</td>
                          <td className="po-table-summary-value" colSpan="2">{formatCurrency(internationalCharges.insuranceCharges)}</td>
                        </tr>
                        <tr className="po-table-breakdown-row po-breakdown-amber">
                          <td colSpan="10" className="po-table-summary-label text-right">+ Handling & Clearance (Fixed):</td>
                          <td className="po-table-summary-value" colSpan="2">{formatCurrency(internationalCharges.handlingCharges)}</td>
                        </tr>
                        <tr className="po-table-breakdown-row po-breakdown-blue-bold">
                          <td colSpan="10" className="po-table-summary-label text-right">
                            <strong>= CIF Value (Cost + Insurance + Freight):</strong>
                          </td>
                          <td className="po-table-summary-value" colSpan="2">
                            <strong>{formatCurrency(totals.cifValue)}</strong>
                          </td>
                        </tr>
                        <tr className="po-table-breakdown-row po-breakdown-purple">
                          <td colSpan="10" className="po-table-summary-label text-right">Basic Customs Duty (BCD on CIF):</td>
                          <td className="po-table-summary-value" colSpan="2">{formatCurrency(totals.basicCustomsDuty)}</td>
                        </tr>
                        <tr className="po-table-breakdown-row po-breakdown-purple">
                          <td colSpan="10" className="po-table-summary-label text-right">Social Welfare Surcharge (10% of BCD):</td>
                          <td className="po-table-summary-value" colSpan="2">{formatCurrency(totals.socialWelfareSurcharge)}</td>
                        </tr>
                        <tr className="po-table-breakdown-row po-breakdown-blue-bold">
                          <td colSpan="10" className="po-table-summary-label text-right">
                            <strong>= Assessable Value (CIF + BCD + SWS):</strong>
                          </td>
                          <td className="po-table-summary-value" colSpan="2">
                            <strong>{formatCurrency(totals.assessableValue)}</strong>
                          </td>
                        </tr>
                        <tr className="po-table-breakdown-row po-breakdown-green">
                          <td colSpan="10" className="po-table-summary-label text-right">IGST (on Assessable Value):</td>
                          <td className="po-table-summary-value" colSpan="2">{formatCurrency(totals.igstOnAssessable)}</td>
                        </tr>
                      </>
                    ) : formData.tradeScenario === 'IN Inter-State (Between Indian States)' ? (
                      <>
                        <tr className="po-table-summary-row">
                          <td colSpan="9" className="po-table-summary-label">IGST:</td>
                          <td className="po-table-summary-value" colSpan="2">{formatCurrency(totals.igst)}</td>
                        </tr>
                        <tr className="po-table-summary-row">
                          <td colSpan="9" className="po-table-summary-label">CESS:</td>
                          <td className="po-table-summary-value" colSpan="2">{formatCurrency(totals.cess)}</td>
                        </tr>
                      </>
                    ) : formData.tradeScenario === 'IN Intra-State (Same State in India)' ? (
                      <>
                        <tr className="po-table-summary-row">
                          <td colSpan="10" className="po-table-summary-label">CGST:</td>
                          <td className="po-table-summary-value" colSpan="2">{formatCurrency(totals.cgst)}</td>
                        </tr>
                        <tr className="po-table-summary-row">
                          <td colSpan="10" className="po-table-summary-label">SGST:</td>
                          <td className="po-table-summary-value" colSpan="2">{formatCurrency(totals.sgst)}</td>
                        </tr>
                        <tr className="po-table-summary-row">
                          <td colSpan="10" className="po-table-summary-label">CESS:</td>
                          <td className="po-table-summary-value" colSpan="2">{formatCurrency(totals.cess)}</td>
                        </tr>
                      </>
                    ) : null}
                    <tr className={`po-table-summary-row po-table-grand-total ${isInternationalTrade(formData.tradeScenario) && formData.tradeScenario !== 'IN→ Export from India (India → Abroad)' ? 'po-breakdown-green-bold' : formData.tradeScenario === 'IN→ Export from India (India → Abroad)' || formData.tradeScenario === 'Third Country (Abroad → Abroad)' ? 'po-breakdown-green-bold' : ''}`}>
                      <td colSpan={formData.tradeScenario === 'Third Country (Abroad → Abroad)' ? "8" : formData.tradeScenario === 'IN Inter-State (Between Indian States)' || formData.tradeScenario === 'IN→ Export from India (India → Abroad)' ? "9" : "10"} className="po-table-summary-label text-right">
                        <strong>Grand Total (Sum of Line Items):</strong>
                      </td>
                      <td className="po-table-summary-value" colSpan="2">
                        <strong>{formatCurrency(totals.grandTotal)}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            
            {/* Import Calculation Verification */}
            {formData.tradeScenario === '→IN Import to India (Abroad → India)' && (
              <div className="po-import-verification">
                <p className="po-verification-title"><strong>Import Calculation Verification:</strong></p>
                <div className="po-verification-content">
                  <p>• Subtotal (Σ Qty × Unit Price) = {formatCurrency(totals.subtotal)}</p>
                  <p>• Less: Total Discount = {formatCurrency(totals.totalDiscount)}</p>
                  <p>• FOB Value (Subtotal - Discount) = {formatCurrency(totals.fobValue)}</p>
                  <p className="po-verification-checkmark">✓ Each line item total includes: Item FOB + Proportional (Freight + Insurance + Handling) + BCD + SWS + IGST + CESS</p>
                  <p className="po-verification-checkmark">✓ Sum of all line item totals = {formatCurrency(totals.grandTotal)}</p>
                  <p className="po-verification-checkmark">✓ Calculation follows Indian Customs Act: BCD on CIF, IGST on Assessable Value (CIF + BCD + SWS)</p>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Delivery Schedule Card */}
        <div className="po-line-items-card">
          <div className="po-line-items-header">
            <div className="po-line-items-header-left">
              <h4 className="po-line-items-title">Delivery Schedule (Optional)</h4>
              <p className="po-line-items-subtitle">
                Specify multiple deliveries for items if required
              </p>
            </div>
            <button className="po-btn-add-line-item" onClick={handleAddDeliverySchedule} type="button">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="po-add-icon">
                <path d="M5 12h14"></path>
                <path d="M12 5v14"></path>
              </svg>
              Add Delivery Schedule
            </button>
          </div>
          <div className="po-line-items-content">
            <div className="po-table-wrapper">
              <table className="po-line-items-table">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Quantity</th>
                    <th>Delivery Date</th>
                    <th>Location</th>
                    <th className="po-table-col-action">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {deliverySchedules.map((schedule) => (
                    <tr key={schedule.id}>
                      <td>
                        <select 
                          className="po-table-input po-table-input-select"
                          value={schedule.item || ''}
                          onChange={(e) => setDeliverySchedules(prev => prev.map(s => 
                            s.id === schedule.id ? { ...s, item: e.target.value } : s
                          ))}
                        >
                          <option value="">Select Item</option>
                          {lineItems.map((item, idx) => (
                            <option key={item.id} value={item.id}>
                              Item {idx + 1} - {item.description}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <input 
                          type="number" 
                          className="po-table-input po-table-input-number"
                          value={schedule.quantity}
                          onChange={(e) => setDeliverySchedules(prev => prev.map(s => 
                            s.id === schedule.id ? { ...s, quantity: e.target.value } : s
                          ))}
                        />
                      </td>
                      <td>
                        <input 
                          type="date" 
                          className="po-table-input po-table-input-date"
                          value={schedule.deliveryDate}
                          onChange={(e) => setDeliverySchedules(prev => prev.map(s => 
                            s.id === schedule.id ? { ...s, deliveryDate: e.target.value } : s
                          ))}
                        />
                      </td>
                      <td>
                        <input 
                          type="text" 
                          className="po-table-input"
                          placeholder="Warehouse/Location"
                          value={schedule.location}
                          onChange={(e) => setDeliverySchedules(prev => prev.map(s => 
                            s.id === schedule.id ? { ...s, location: e.target.value } : s
                          ))}
                        />
                      </td>
                      <td>
                        <button 
                          className="po-btn-delete-item"
                          onClick={() => handleDeleteDeliverySchedule(schedule.id)}
                          type="button"
                          title="Remove schedule"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="po-delete-icon">
                            <path d="M10 11v6"></path>
                            <path d="M14 11v6"></path>
                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path>
                            <path d="M3 6h18"></path>
                            <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                          </svg>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Terms & Conditions Card */}
        <div className="po-line-items-card">
          <div className="po-line-items-header">
            <div className="po-line-items-header-left">
              <h4 className="po-line-items-title">Terms & Conditions</h4>
              <p className="po-line-items-subtitle">
                Standard and custom terms applicable to this purchase order
              </p>
            </div>
            <button className="po-btn-add-line-item" onClick={handleAddTerm} type="button">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="po-add-icon">
                <path d="M5 12h14"></path>
                <path d="M12 5v14"></path>
              </svg>
              Add Term/Condition
            </button>
          </div>
          <div className="po-line-items-content">
            <div className="po-terms-list">
              {termsConditions.map((term, index) => (
                <div key={term.id} className="po-term-item">
                  <span className="po-term-number">{index + 1}.</span>
                  <textarea
                    className="po-term-textarea"
                    rows="1"
                    value={term.text}
                    onChange={(e) => handleTermChange(term.id, e.target.value)}
                    placeholder="Enter term/condition"
                  />
                  <button 
                    className="po-btn-delete-term"
                    onClick={() => handleDeleteTerm(term.id)}
                    type="button"
                    title="Remove term"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="po-delete-icon">
                      <path d="M10 11v6"></path>
                      <path d="M14 11v6"></path>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path>
                      <path d="M3 6h18"></path>
                      <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    </svg>
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Special Instructions Card */}
        <div className="po-line-items-card">
          <div className="po-line-items-header">
            <div className="po-line-items-header-left">
              <h4 className="po-line-items-title">Special Instructions</h4>
            </div>
          </div>
          <div className="po-line-items-content">
            <textarea
              className="po-special-instructions-textarea"
              value={specialInstructions}
              onChange={handleSpecialInstructionsChange}
              placeholder="Any special packaging, labeling, or delivery instructions..."
            />
          </div>
        </div>

        {/* Attachments Card */}
        <div className="po-line-items-card">
          <div className="po-line-items-header">
            <div className="po-line-items-header-left">
              <h4 className="po-line-items-title po-attachments-title">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="po-attachments-icon">
                  <path d="M12 3v12"></path>
                  <path d="m17 8-5-5-5 5"></path>
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                </svg>
                Attachments
              </h4>
              <p className="po-line-items-subtitle">
                Attach relevant documents (RFQ, specifications, drawings)
              </p>
            </div>
            <label className="po-btn-add-line-item">
              <input 
                type="file" 
                multiple 
                onChange={handleFileUpload}
                style={{ display: 'none' }}
              />
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="po-add-icon">
                <path d="M12 3v12"></path>
                <path d="m17 8-5-5-5 5"></path>
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              </svg>
              Upload File
            </label>
          </div>
          <div className="po-line-items-content">
            <div className="po-attachments-list">
              {attachments.map((attachment) => (
                <div key={attachment.id} className="po-attachment-item">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="po-attachment-icon">
                    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                    <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                    <path d="M10 9H8"></path>
                    <path d="M16 13H8"></path>
                    <path d="M16 17H8"></path>
                  </svg>
                  <span className="po-attachment-name">{attachment.name}</span>
                  <button 
                    className="po-btn-delete-attachment"
                    onClick={() => handleDeleteAttachment(attachment.id)}
                    type="button"
                    title="Remove file"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="po-delete-icon">
                      <path d="M10 11v6"></path>
                      <path d="M14 11v6"></path>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path>
                      <path d="M3 6h18"></path>
                      <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    </svg>
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Preview Modal */}
      {showPreviewModal && (
        <div className="po-preview-modal-overlay" onClick={() => setShowPreviewModal(false)}>
          <div className="po-preview-modal" onClick={(e) => e.stopPropagation()}>
            <div className="po-preview-modal-header">
              <div className="po-preview-modal-header-left">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="po-preview-icon">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                <div>
                  <h2 className="po-preview-modal-title">Preview Purchase Order</h2>
                  <p className="po-preview-modal-subtitle">Review all details before updating</p>
                </div>
              </div>
              <button className="po-preview-modal-close" onClick={() => setShowPreviewModal(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>

            <div className="po-preview-modal-body">
              {/* Reference Quotation */}
              <div className="po-preview-section">
                <h3 className="po-preview-section-title">Reference Quotation</h3>
                <div className="po-preview-grid">
                  <div className="po-preview-item">
                    <label>Quotation ID</label>
                    <p>{quotationData.quotationId}</p>
                  </div>
                  <div className="po-preview-item">
                    <label>Linked RFQ</label>
                    <p>{quotationData.linkedRFQ}</p>
                  </div>
                  <div className="po-preview-item">
                    <label>Quote Date</label>
                    <p>{quotationData.quoteDate}</p>
                  </div>
                  <div className="po-preview-item">
                    <label>Valid Until</label>
                    <p>{quotationData.validUntil}</p>
                  </div>
                </div>
              </div>

              {/* PO Header Info */}
              <div className="po-preview-section">
                <h3 className="po-preview-section-title">Purchase Order Details</h3>
                <div className="po-preview-grid">
                  <div className="po-preview-item">
                    <label>PO Number</label>
                    <p>{formData.poNumber}</p>
                  </div>
                  <div className="po-preview-item">
                    <label>PO Date</label>
                    <p>{formData.poDate}</p>
                  </div>
                  <div className="po-preview-item">
                    <label>Expected Delivery Date</label>
                    <p>{formData.expectedDeliveryDate}</p>
                  </div>
                  <div className="po-preview-item">
                    <label>Priority Level</label>
                    <p>{formData.priorityLevel}</p>
                  </div>
                  <div className="po-preview-item">
                    <label>Payment Terms</label>
                    <p>{getPaymentTermLabel(formData.paymentTerms)}</p>
                  </div>
                  <div className="po-preview-item">
                    <label>Currency</label>
                    <p>{formData.currency || 'INR'}</p>
                  </div>
                  <div className="po-preview-item">
                    <label>Freight Terms</label>
                    <p>{formData.freightTerms || 'Not specified'}</p>
                  </div>
                  <div className="po-preview-item">
                    <label>Delivery Terms</label>
                    <p>{getDeliveryTermLabel(formData.deliveryTerms)}</p>
                  </div>
                  <div className="po-preview-item">
                    <label>Trade Scenario</label>
                    <p>{formData.tradeScenario}</p>
                  </div>
                </div>
              </div>

              {/* International Trade Details */}
              {isInternationalTrade(formData.tradeScenario) && (
                <div className="po-preview-section">
                  <h3 className="po-preview-section-title">International Trade Details</h3>
                  <div className="po-preview-grid">
                    <div className="po-preview-item">
                      <label>Port of Loading</label>
                      <p>{formData.portOfLoading || 'Not specified'}</p>
                    </div>
                    <div className="po-preview-item">
                      <label>Port of Discharge</label>
                      <p>{formData.portOfDischarge || 'Not specified'}</p>
                    </div>
                    <div className="po-preview-item">
                      <label>Customs Broker/CHA</label>
                      <p>{formData.customsBroker || 'Not specified'}</p>
                    </div>
                    <div className="po-preview-item">
                      <label>HS Code</label>
                      <p>{formData.hsCode || 'Not specified'}</p>
                    </div>
                    <div className="po-preview-item">
                      <label>Country of Origin</label>
                      <p>{formData.countryOfOrigin || 'Not specified'}</p>
                    </div>
                    <div className="po-preview-item">
                      <label>Incoterms</label>
                      <p>{formData.incoterms || 'Not specified'}</p>
                    </div>
                  </div>
                  {internationalCharges && (
                    <div className="po-preview-grid" style={{ marginTop: '16px' }}>
                      <div className="po-preview-item">
                        <label>Shipping Charges</label>
                        <p>{formatCurrency(internationalCharges.shippingCharges)}</p>
                      </div>
                      <div className="po-preview-item">
                        <label>Insurance Charges</label>
                        <p>{formatCurrency(internationalCharges.insuranceCharges)}</p>
                      </div>
                      <div className="po-preview-item">
                        <label>Handling & Clearance Charges</label>
                        <p>{formatCurrency(internationalCharges.handlingCharges)}</p>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Buyer & Seller Details */}
              <div className="po-preview-section">
                <h3 className="po-preview-section-title">Buyer & Seller Information</h3>
                <div className="po-preview-grid-2">
                  <div className="po-preview-card">
                    <h4 className="po-preview-card-title">Buyer Details</h4>
                    <div className="po-preview-details">
                      <p><strong>Company:</strong> {buyerDetails.companyName}</p>
                      <p><strong>Address:</strong> {formData.buyerAddress}</p>
                      <p><strong>GST:</strong> {formData.buyerGstNumber}</p>
                      <p><strong>State:</strong> {formData.buyerState}</p>
                      <p><strong>Country:</strong> {formData.buyerCountry}</p>
                    </div>
                  </div>
                  <div className="po-preview-card">
                    <h4 className="po-preview-card-title">Seller Details</h4>
                    <div className="po-preview-details">
                      <p><strong>Company:</strong> {sellerDetails.companyName}</p>
                      <p><strong>Address:</strong> {formData.sellerAddress}</p>
                      <p><strong>GST:</strong> {formData.sellerGstNumber}</p>
                      <p><strong>State:</strong> {formData.sellerState}</p>
                      <p><strong>Country:</strong> {formData.sellerCountry}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Line Items */}
              <div className="po-preview-section">
                <h3 className="po-preview-section-title">Line Items</h3>
                <div className="po-preview-table-wrapper">
                  <table className="po-preview-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Description</th>
                        <th>HSN</th>
                        <th>Qty</th>
                        <th>UOM</th>
                        <th>Unit Price</th>
                        <th>Disc %</th>
                        {isInternationalTrade(formData.tradeScenario) ? (
                          <>
                            <th>Customs %</th>
                            <th>IGST %</th>
                            <th>CESS %</th>
                          </>
                        ) : formData.tradeScenario === 'IN Inter-State (Between Indian States)' ? (
                          <>
                            <th>IGST %</th>
                            <th>CESS %</th>
                          </>
                        ) : (
                          <>
                            <th>CGST %</th>
                            <th>SGST %</th>
                            <th>CESS %</th>
                          </>
                        )}
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lineItems.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.description}</td>
                          <td>{item.hsn}</td>
                          <td>{item.quantity}</td>
                          <td>{item.uom}</td>
                          <td>{formatCurrency(item.unitPrice)}</td>
                          <td>{item.discount}%</td>
                          {isInternationalTrade(formData.tradeScenario) ? (
                            <>
                              <td>{item.customsDuty || 0}%</td>
                              <td>{item.igst}%</td>
                              <td>{item.cess}%</td>
                            </>
                          ) : formData.tradeScenario === 'IN Inter-State (Between Indian States)' ? (
                            <>
                              <td>{item.igst}%</td>
                              <td>{item.cess}%</td>
                            </>
                          ) : (
                            <>
                              <td>{item.cgst}%</td>
                              <td>{item.sgst}%</td>
                              <td>{item.cess}%</td>
                            </>
                          )}
                          <td>{formatCurrency(item.total)}</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      {formData.tradeScenario !== '→IN Import to India (Abroad → India)' && (
                        <tr className="po-preview-total-row">
                          <td colSpan={isInternationalTrade(formData.tradeScenario) ? "10" : formData.tradeScenario === 'IN Inter-State (Between Indian States)' ? "9" : "10"} className="po-preview-summary-label">Subtotal (Qty × Unit Price):</td>
                          <td className="po-preview-summary-value">{formatCurrency(totals.subtotal)}</td>
                        </tr>
                      )}
                      {isInternationalTrade(formData.tradeScenario) ? (
                        <>
                          <tr className="po-preview-total-row">
                            <td colSpan="10" className="po-preview-summary-label">Basic Customs Duty (BCD):</td>
                            <td className="po-preview-summary-value">{formatCurrency(totals.basicCustomsDuty || 0)}</td>
                          </tr>
                          <tr className="po-preview-total-row">
                            <td colSpan="10" className="po-preview-summary-label">Social Welfare Surcharge (10% of BCD):</td>
                            <td className="po-preview-summary-value">{formatCurrency(totals.socialWelfareSurcharge || 0)}</td>
                          </tr>
                          <tr className="po-preview-total-row">
                            <td colSpan="10" className="po-preview-summary-label">Assessable Value (CIF + BCD + SWS):</td>
                            <td className="po-preview-summary-value">{formatCurrency(totals.assessableValue || 0)}</td>
                          </tr>
                          <tr className="po-preview-total-row">
                            <td colSpan="10" className="po-preview-summary-label">IGST (on Assessable Value):</td>
                            <td className="po-preview-summary-value">{formatCurrency(totals.igstOnAssessable || 0)}</td>
                          </tr>
                          <tr className="po-preview-total-row">
                            <td colSpan="10" className="po-preview-summary-label">Shipping Charges:</td>
                            <td className="po-preview-summary-value">{formatCurrency(internationalCharges.shippingCharges)}</td>
                          </tr>
                          <tr className="po-preview-total-row">
                            <td colSpan="10" className="po-preview-summary-label">Insurance Charges:</td>
                            <td className="po-preview-summary-value">{formatCurrency(internationalCharges.insuranceCharges)}</td>
                          </tr>
                          <tr className="po-preview-total-row">
                            <td colSpan="10" className="po-preview-summary-label">Handling & Clearance Charges:</td>
                            <td className="po-preview-summary-value">{formatCurrency(internationalCharges.handlingCharges)}</td>
                          </tr>
                        </>
                      ) : formData.tradeScenario === 'IN Inter-State (Between Indian States)' ? (
                        <>
                          <tr className="po-preview-total-row">
                            <td colSpan="9" className="po-preview-summary-label">IGST:</td>
                            <td className="po-preview-summary-value">{formatCurrency(totals.igst)}</td>
                          </tr>
                          <tr className="po-preview-total-row">
                            <td colSpan="9" className="po-preview-summary-label">CESS:</td>
                            <td className="po-preview-summary-value">{formatCurrency(totals.cess)}</td>
                          </tr>
                        </>
                      ) : (
                        <>
                          <tr className="po-preview-total-row">
                            <td colSpan="10" className="po-preview-summary-label">CGST:</td>
                            <td className="po-preview-summary-value">{formatCurrency(totals.cgst)}</td>
                          </tr>
                          <tr className="po-preview-total-row">
                            <td colSpan="10" className="po-preview-summary-label">SGST:</td>
                            <td className="po-preview-summary-value">{formatCurrency(totals.sgst)}</td>
                          </tr>
                          <tr className="po-preview-total-row">
                            <td colSpan="10" className="po-preview-summary-label">CESS:</td>
                            <td className="po-preview-summary-value">{formatCurrency(totals.cess)}</td>
                          </tr>
                        </>
                      )}
                      <tr className="po-preview-total-row po-preview-grand-total">
                        <td colSpan={isInternationalTrade(formData.tradeScenario) ? "10" : formData.tradeScenario === 'IN Inter-State (Between Indian States)' ? "9" : "10"} className="po-preview-summary-label">
                          <strong>Grand Total (Sum of Line Items):</strong>
                        </td>
                        <td className="po-preview-summary-value">
                          <strong>{formatCurrency(totals.grandTotal)}</strong>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>

              {/* Delivery Schedule */}
              {deliverySchedules.length > 0 && (
                <div className="po-preview-section">
                  <h3 className="po-preview-section-title">Delivery Schedule</h3>
                  <div className="po-preview-table-wrapper">
                    <table className="po-preview-table">
                      <thead>
                        <tr>
                          <th>Item</th>
                          <th>Quantity</th>
                          <th>Delivery Date</th>
                          <th>Location</th>
                        </tr>
                      </thead>
                      <tbody>
                        {deliverySchedules.map((schedule) => {
                          const item = lineItems.find(i => i.id.toString() === schedule.item.toString());
                          return (
                            <tr key={schedule.id}>
                              <td>{item ? item.description : `Item ${schedule.item}`}</td>
                              <td>{schedule.quantity}</td>
                              <td>{schedule.deliveryDate}</td>
                              <td>{schedule.location}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Terms & Conditions */}
              {termsConditions.length > 0 && (
                <div className="po-preview-section">
                  <h3 className="po-preview-section-title">Terms & Conditions</h3>
                  <ol className="po-preview-terms-list">
                    {termsConditions.map((term, index) => (
                      <li key={term.id}>{term.text}</li>
                    ))}
                  </ol>
                </div>
              )}

              {/* Special Instructions */}
              {specialInstructions && (
                <div className="po-preview-section">
                  <h3 className="po-preview-section-title">Special Instructions</h3>
                  <p className="po-preview-text">{specialInstructions}</p>
                </div>
              )}

              {/* Attachments */}
              {attachments.length > 0 && (
                <div className="po-preview-section">
                  <h3 className="po-preview-section-title">Attachments</h3>
                  <div className="po-preview-attachments-list">
                    {attachments.map((attachment) => (
                      <div key={attachment.id} className="po-preview-attachment-item">
                        <div className="po-preview-attachment-info">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="po-preview-attachment-icon">
                            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                            <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                            <path d="M10 9H8"></path>
                            <path d="M16 13H8"></path>
                            <path d="M16 17H8"></path>
                          </svg>
                          <span className="po-preview-attachment-name">{attachment.name}</span>
                        </div>
                        <button 
                          className="po-preview-view-document-btn"
                          onClick={() => {
                            // Open document in new tab (you can replace with actual document URL)
                            window.open(`/documents/${attachment.name}`, '_blank');
                          }}
                          title="View Document"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                          </svg>
                          View Document
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="po-preview-modal-footer">
              <button className="po-btn-secondary" onClick={() => setShowPreviewModal(false)}>
                Close
              </button>
              <button className="po-btn-primary" onClick={() => {
                setShowPreviewModal(false);
                handleSubmit();
              }}>
                Update Purchase Order
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

